import React from 'react';

interface LabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string | undefined;
  showIcon?: boolean;
}

export const Label: React.FC<LabelProps> = ({ children, htmlFor, className = '' }) => {
  const preventSelection = (e: React.MouseEvent) => {
    if (e.detail > 1) {
      e.preventDefault();
    }
  };

  return (
    <>
      <label
        htmlFor={htmlFor}
        className={`iLendingCDX-input-label ${className}`}
        onMouseDown={preventSelection}
      >
        {children}
        {'   '}
      </label>
    </>
  );
};
